import { LOGIN_SUCCESS, SET_HOTEL_ID } from "../actionTypes";

export const LoginSuccess = (data: any) => {
  return {
    type: LOGIN_SUCCESS,
    payload: data,
  };
  
};

export const setHotelId = (hotel_id) => ({
  type: SET_HOTEL_ID,
  payload: { hotel_id },
});

